import { updateRecipeFromModel } from '@akin-home/recipes-front-end';
import { useMutation, useQueryClient } from 'react-query';
import { recipesQueryKey } from './query_key';

export const useUpdateRecipe = () => {
  const client = useQueryClient();

  return useMutation(updateRecipeFromModel, {
    onSuccess(data) {
      client.invalidateQueries(recipesQueryKey.lists());
      client.invalidateQueries(recipesQueryKey.all_pages());
      client.removeQueries(recipesQueryKey.detail(data.id));
    },
  });
};
